import {TemplateList} from "../libs/constants/TemplateList"
import {RecommendPlacementId} from "../libs/constants/RecommendPlacementId"
import type RecombeeScenarioItem from "../libs/interfaces/RecombeeScenarioItem"
import {RecombeeRecommendType} from "../libs/constants/RecombeeRecommendType"

export const RecombeeScenariosConfig: Record<TemplateList, RecombeeScenarioItem[]> = {
  [TemplateList.POGGERS]: [
    {
      placementId: RecommendPlacementId.HOMEPAGE_EXTERNAL,
      type: RecombeeRecommendType.RECOMMEND_ITEMS_TO_USER,
      scenario: 'poggers-hp-odjinud',
      pageQueryParam: 'recommExtPage'
    },
    {
      placementId: RecommendPlacementId.ARTICLE_DETAIL_RELATED,
      type: RecombeeRecommendType.RECOMMEND_ITEMS_TO_ITEM,
      scenario: 'poggers-article-doporucujeme',
      pageQueryParam: 'recommArticleRecPage'
    },
    {
      placementId: RecommendPlacementId.ARTICLE_DETAIL_EXTERNAL,
      type: RecombeeRecommendType.RECOMMEND_ITEMS_TO_USER,
      scenario: 'poggers-article-odjinud',
      pageQueryParam: 'recommArticleExtPage'
    },
    {
      placementId: RecommendPlacementId.SECTION_EXTERNAL,
      type: RecombeeRecommendType.RECOMMEND_ITEMS_TO_USER,
      scenario: 'poggers-kategorie-odjinud',
      pageQueryParam: 'recommSectionExtPage'
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    // no recombee
  ]
}